import { useI18n } from '~Hooks';

/** Non-technical labels used when rendering blueprint values (ON/OFF instead of true/false) */
const useBlueprintValueLabels = () => {
  const { i18n } = useI18n();

  return {
    on: i18n('Settings.Blueprints.ValueOn'),
    off: i18n('Settings.Blueprints.ValueOff'),
    empty: i18n('Settings.Blueprints.ValueEmpty'),
  };
};

export default useBlueprintValueLabels;
